import React from 'react';
import PropTypes from 'prop-types';
import { Card, Radio } from '@one-thd/sui-atomic-components';

const SelectableRadioCard = ({ value, selected, disabled, label, children }) => {
  const radioId = `selectable-radio-card-${value}`;

  return (
    <div
      className={
        `sui-mb-4 sui-rounded-lg sui-border-solid sui-border-1 sui-overflow-hidden ${
          disabled ? 'sui-border-primary sui-bg-subtle' : 'sui-border-strong'
        }${selected ? ' sui-shadow-sm' : ''}`
      }
    >
      <Card
        variant="shadow"
        grow
        PaperProps={{ shadow: 'none' }}
        CardContentProps={{ disableGutters: true, disablePadding: true }}
      >
        <div className="sui-p-1">
          {/*
            A plain native label/radio pairing instead of SelectionControlLabel: that component's
            `label` prop is typed as a string, but we need a styled span here (bold when selected),
            which triggered a PropTypes warning. htmlFor/id keeps the same click-to-toggle behavior.
          */}
          <label
            htmlFor={radioId}
            className={
              `sui-inline-flex sui-items-center sui-w-full ${disabled ? 'sui-cursor-default' : 'sui-cursor-pointer'}`
            }
          >
            <Radio
              id={radioId}
              value={value}
              disabled={disabled}
              className={
                'sui-flex sui-justify-center sui-relative sui-box-border sui-bg-transparent '
                + 'sui-align-middle sui-outline-0 sui-border-0 sui-m-0 sui-p-0 sui-select-none '
                + 'sui-appearance-none sui-no-underline sui-items-center '
                + (disabled
                  ? 'sui-cursor-default sui-pointer-events-none'
                  : 'sui-cursor-pointer sui-tap-highlight-transparent')
              }
            />
            <span
              className={
                `sui-pl-1 ${disabled ? 'sui-text-inactive' : 'sui-text-primary'} ${
                  selected ? 'sui-font-bold' : 'sui-font-regular'
                }`
              }
            >
              {label}
            </span>
          </label>
          {selected && children}
        </div>
      </Card>
    </div>
  );
};

SelectableRadioCard.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]).isRequired,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.node.isRequired,
  children: PropTypes.node
};

SelectableRadioCard.defaultProps = {
  selected: false,
  disabled: false,
  children: null
};

SelectableRadioCard.displayName = 'SelectableRadioCard';

export { SelectableRadioCard };
